export default {
  root: { display: 'flex', justifyContent: 'center' }
};
